module.exports = __webpack_public_path__ + "mainassets/img/bg-cookie.a3fea245.jpg";